import React, { Component } from "react";
import styles from "./Payment.module.sass";
import formStyles from "../../components/UserForms/UserForm.module.sass";
import theme from "../../App.module.sass";

import UserDataSummary from "../../components/UserDataSummary/UserDataSummary";
import PurchaseDetailsCard from "../../components/PurchaseDetailsCard/PurchaseDetailsCard";
import PaymentDetails from "../../components/PaymentDetails/PaymentDetails";
import api from "../../utils/api";

import Button from "../../components/ui/Button/Button";
import AppContext from "../../contexts/appContext";
import gaTags from "./../../utils/ga-tags";
import { getCreditCardType } from "../../utils/creditCardUtils";
import useChatUrl from "../../hooks/useChatUrl";
import { parseCC } from "../../utils/accounts";

import env from "../../config/environment";
import * as lgpdApi from "../../utils/lgpd-api";

const ChatLink = () => {
  const { callChat } = useChatUrl();

  return (
    <span onClick={() => callChat()} className={theme.link}>
      {" "}
      chat
    </span>
  );
};

const handleError = (error, context, history) => {
  if (error.response.data.code == null) {
    context.setContext({
      ...context,
      error: {
        show: true,
        msg: error.response.data.hasOwnProperty("erro")
          ? error.response.data.erro.httpMessage
          : error.response.data.httpMessage,
      },
    });
    return;
  }

  if (error.response.data.code > 100 && error.response.data.code <= 200) {
    context.setContext({
      ...context,
      error: {
        show: true,
        msg: error.response.data.httpMessage,
        additionalMsg: (
          <p>
            Caso queira alterá-lo, fale com a gente pelo
            <ChatLink /> :)
          </p>
        ),
        showChat: true,
        onHide: () => {
          history.push({
            pathname: "/produtos",
          });
        },
      },
    });
  } else if (
    error.response.data.code > 200 &&
    error.response.data.code <= 300
  ) {
    const onHideHandler = () => {
      context.setContext({
        ...context,
        title: "Esta oferta não está mais disponível :(",
        subtitle:
          "Temos outras ofertas para você. Lembre-se que as cotas estão sujeitas a disponibilidade.",
        redirectToPayment: true,
        error: {
          show: false,
          body: null,
        },
      });
      history.push({
        pathname: "/ofertas",
      });
    };

    context.setContext({
      ...context,
      error: {
        show: true,
        msg: error.response.data.httpMessage,
        additionalMsg: (
          <p>
            Temos outras ofertas pra você. Clique
            <span onClick={onHideHandler} className={theme.link}>
              {" "}
              aqui
            </span>{" "}
            para prosseguir.
          </p>
        ),
        showChat: true,
        onHide: onHideHandler,
      },
    });
  } else {
    context.setContext({
      ...context,
      error: {
        show: true,
        msg: error.response.data.httpMessage,
      },
    });
  }
};

class Payment extends Component {
  state = {
    parcelas: [],
    paymentInfo: {},
    secondaryPaymentInfo: {},
  };

  static contextType = AppContext;

  getBasePayload = () => ({
    codigoComissionado: api.CODIGO_COMISSIONADO(),
    codigoUsuario: api.CODIGO_USUARIO(),
    identificacao: {
      codigoCotacao: this.context.cotationCode,
    },
    corporativo: {
      codigoProduto: this.context.product.id === "1" ? "601" : "611",
    },
    grupo: {
      codigo: this.context.selectedOffer.identificacao.codigo,
      codigoBem: this.context.selectedOffer.codigoBem,
      codigoPlano: this.context.selectedOffer.dados.plano.identificacao.codigo,
      quantidadeParticipantes: this.context.selectedOffer.dados.vagas.total,
      prazo: this.context.selectedOffer.dados.plano.prazo.total,
      codigoProduto: this.context.selectedOffer.codigoProduto,
      codigoTaxa: this.context.selectedOffer.dados.plano.identificacao
        .codigoTaxa,
      codigoVenda: this.context.selectedOffer.identificacao.codigoVenda,
      codigoTipoVenda: this.context.selectedOffer.codigoTipoVenda,
      situacao: this.context.selectedOffer.dados.situacao,
    },
    pagamento: {
      condicao: this.state.paymentInfo.method,
    },
    pessoa: {
      cpfCnpj: this.context.document,
    },
    seguro: {
      prestamista: this.context.insurance,
    },
    snOfertaOutroProduto: this.context.lgpdConsent === '1' ? 's' : 'n',
    snOfertaOutroProdutoParceiro: this.context.lgpdConsent === '1' ? 's' : 'n'
  });

  formatAccountInfo = (account) => ({
    agencia: {
      digito: "",
      numero: account.agency,
    },
    conta: {
      operacao: account.operation,
      tipo:
        account.operation === "001" || account.operation === "003" ? "C" : "P",
      digito: account.dv || account.digit,
      numero: account.account,
    },
    favorecido: {
      nome: this.context.client.pessoa.nome,
      cpfCnpj: this.context.document,
    },
  });

  submitHandler = () => {
    const requestBody = this.getBasePayload();
    if (
      this.state.paymentInfo.method !== "DB" &&
      this.state.secondaryPaymentInfo.method !== "DB" &&
      this.context.ibcUser &&
      this.context.ibcUser.accounts[0]
    ) {
      const ibcAccount = parseCC(this.context.ibcUser.accounts[0]);
      requestBody.pagamento.debito = this.formatAccountInfo(ibcAccount);
    }

    if (this.state.paymentInfo.method === "DB") {
      requestBody.pagamento.debito = this.formatAccountInfo(
        this.state.paymentInfo.debitInfo
      );
    }

    if (this.state.paymentInfo.method === "CC") {
      requestBody.pagamento.cartaoCredito = {
        favorecido: {
          nome: this.state.paymentInfo.creditInfo.titular,
          cpfCnpj: this.state.paymentInfo.creditInfo.titularCPF,
        },
        numeroCartao: this.state.paymentInfo.creditInfo.cardNumber,
        digitoVerificador: this.state.paymentInfo.creditInfo.ccv,
        dataValidade: this.state.paymentInfo.creditInfo.validity.replace(
          /(\d{2})(\d{2})/,
          "$1/20$2"
        ),
        bandeira: getCreditCardType(
          this.state.paymentInfo.creditInfo.cardNumber
        ).name,
      };
    }

    if (this.state.secondaryPaymentInfo.method === "BB") {
      requestBody.demaisParcelas = {
        condicao: "BB",
      };
    }

    if (this.state.secondaryPaymentInfo.method === "DB") {
      requestBody.pagamento.debito = this.formatAccountInfo(
        this.state.secondaryPaymentInfo.debitInfo
      );

      requestBody.demaisParcelas = {
        condicao: "DB",
        debito: this.formatAccountInfo(
          this.state.secondaryPaymentInfo.debitInfo
        ),
      };
    }

    api
      .post(api.endpoints.PROPOSTA, requestBody)
      .then((result) => {
        this.context.setContext({
          ...this.context,
          proposalCode: result.data.proposta.codigo,
          paymentType: this.state.paymentInfo.method,
        });
        if (result.data.proposta.codigo) {
          this.sendLgpdConsent(result.data.proposta.codigo);
        }
      })
      .catch((error) => {
        handleError(error, this.context, this.props.history);
      });
  };

  componentDidMount() {
    const selectedOffer = this.context.selectedOffer;

    const requestBody = {
      grupo: {
        codigo: selectedOffer.identificacao.codigo,
        codigoPlanoVenda: selectedOffer.dados.plano.identificacao.codigo,
        codigoTaxaPlano: selectedOffer.dados.plano.identificacao.codigoTaxa,
        codigoVenda: selectedOffer.identificacao.codigoVenda,
        lanceMedio: selectedOffer.dados.valorLanceMedio,
      },
      codigoBem: selectedOffer.codigoBem,
      codigoComissionado: api.CODIGO_COMISSIONADO(),
      codigoEmpresa: api.CODIGO_EMPRESA,
    };

    api.post(api.endpoints.OFFERS_DETAILS, requestBody).then((result) => {
      this.setState({
        parcelas: result.data.dados.plano.detalhes.parcelas,
      });
    });
  }

  checkPaymentDisabled = () => {
    return (
      this.state.paymentInfo.method === "" ||
      (this.state.paymentInfo.method === "DB" &&
        this.state.paymentInfo.debitInfo.accountIndex === -1) ||
      (this.state.paymentInfo.method === "CC" &&
        (!this.state.secondaryPaymentInfo.method ||
          (this.state.secondaryPaymentInfo.method === "DB" &&
            this.state.secondaryPaymentInfo.debitInfo.accountIndex === -1)))
    );
  };

  getPaymentLabel = () => {
    if (this.state.paymentInfo.method === "CC") {
      return `CartãoCrédito&DemaisParcelas:${this.getContinuousPaymentLabel(
        this.state.secondaryPaymentInfo.method
      )}`;
    }
    return this.getContinuousPaymentLabel(this.state.paymentInfo.method);
  };

  getContinuousPaymentLabel = (method) => {
    return method === "DB" ? "DébitoEmConta" : "Boleto";
  };

  sendLgpdConsent = (proposalCode) => {
    const promises = [
      lgpdApi.postLgpdConsent(
        env.BUSINESS_PROCESS_CODE,
        this.context.document,
        proposalCode,
        this.context.lgpdConsent,
        env.BUSINESS_SUBPROCESS_CAIXA_HOLDING_CODE
      ),
      lgpdApi.postLgpdConsent(
        env.BUSINESS_PROCESS_CODE,
        this.context.document,
        proposalCode,
        this.context.lgpdConsent,
        env.BUSINESS_SUBPROCESS_CAIXA_HOLDING_PARTNERS_CODE
      ),
    ];
    Promise.all(promises).then((res) => {
      if (res.every((el) => el.status === 200)) {
        window.dataLayer.push({
          event: "id-transacao",
          id: proposalCode,
          location: window.location.href,
          time: new Date(),
          ip: window.ip,
        });

        this.props.history.push({
          pathname: "/assinatura",
        });
      }
    });
  };

  render() {
    const methodType = this.getPaymentLabel();
    const gaTypeName = `${gaTags.typeFlow2.concat("4-")}&${
      this.state.paymentInfo.method && methodType
    }&-FormaPagamento`;

    return (
      <div className={styles.Payment}>
        <div className={styles.content}>
          <section
            className={[formStyles.sectionForm, styles.section].join(" ")}
          >
            <UserDataSummary data={this.context} />
          </section>

          <section
            className={[
              formStyles.sectionForm,
              styles.section,
              this.state.paymentInfo.method === "CC" ? styles.cc : "",
            ].join(" ")}
          >
            <PaymentDetails
              parcelaMedia={this.context.selectedOffer.dados.valorParcela}
              selectedIdentifier={this.context.selectedIdentifier}
              ibc={this.context.ibc}
              parcelas={this.state.parcelas}
              onChange={(paymentInfo) => {
                const secondary =
                  paymentInfo.method === "CC"
                    ? this.state.secondaryPaymentInfo
                    : {};
                this.setState({ paymentInfo, secondaryPaymentInfo: secondary });
              }}
            />
          </section>

          {this.state.paymentInfo.method === "CC" && (
            <section
              className={[formStyles.sectionForm, styles.section].join(" ")}
            >
              <PaymentDetails
                parcelaMedia={this.context.selectedOffer.dados.valorParcela}
                selectedIdentifier={this.context.selectedIdentifier}
                ibc={this.context.ibc}
                onChange={(secondaryPaymentInfo) =>
                  this.setState({ secondaryPaymentInfo })
                }
                parcelas={this.state.parcelas}
                secondary
              />
            </section>
          )}

          <footer className={theme.footerForm}>
            <span
              onClick={() =>
                this.props.history.push({
                  pathname:
                    this.context.allowInsurance &&
                    !this.context.ibc &&
                    this.context.selectedIdentifier === "cpf"
                      ? "/seguro"
                      : "dados-cliente",
                })
              }
              className={[theme.backLabel, styles.backLabel].join(" ")}
              role="link"
            >
              <i className="icon icon-seta-esquerda" />
              Voltar
            </span>

            <Button
              onClick={this.submitHandler}
              selected
              disabled={this.checkPaymentDisabled()}
              data-gacategory={gaTags.categoryFlow}
              data-gatype={gaTypeName}
              data-gafunc={`${gaTypeName}-FinalizarCompra`}
            >
              Finalizar Compra
            </Button>
          </footer>
        </div>

        <div className={styles.card}>
          <PurchaseDetailsCard offer={this.context} />
        </div>
      </div>
    );
  }
}

export default Payment;
